import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider } from './Context';
import BasicInformation from './Views/BasicInformation/Index';
import Management from './Views/Management/Index';

export default function Index({ enterpriseId }) {
  return (
    <StrictMode>
      <ContextProvider enterpriseId={enterpriseId}>
        <div className="content">
          <section>
            <h1>General</h1>
          </section>

          <BasicInformation />
        </div>

        <div className="content">
          <Management />
        </div>
      </ContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
